// extracted by mini-css-extract-plugin
export var actionButton = "_9f-0";
export var attachmentLine = "_9f-1";
export var fileInput = "_9f-2";
export var fileUploadWrapper = "_9f-4";
export var footer = "_9f-3";
export var modalContent = "_9f-5";
export var paperclip = "_9f-6";
export var quillEditor = "_9f-7";